export const ADDRESS_CHECK =
  /^(?![.,\s/#º-])(?!.*[.,\s/#º-]$)(?!.*\s[.,/-])(?!.*[.,/-]\s#)(?!.*Nº[^0-9])(?!.*[.,/-]\s#)(?!.*(?:[.,/#º-]{2,}|([.,\s/#-])\1))(?!.*([A-Za-zÀ-ÖØ-öø-ÿ])\2\2)[A-Za-zÀ-ÖØ-öø-ÿ0-9.,\s/#º-]+$/gi
export const CLEAN_DNI_FORMAT = /^0+|[^0-9kK]+/g
export const CURRENCY_DOTS_FORMAT = /(\d)(?=(?:[0-9,]{3})+\b)/g
export const DNI_CHECK = /^(\d{1,3}(?:\.\d{1,3}){2}-[\dkK])$/
export const EMAIL_CHECK =
  /^[a-z0-9]((\.|\+|-|_)?[a-z0-9]){1,}@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
export const ESCAPE_HTML_FORMAT = /[^\w. ]/gi
export const ESCAPE_JS_FORMAT = /javascript:/gi
export const FILTER_PATTERN_CHECK = /[\u0300-\u036f]/g
export const ID_CHECK = /^(?![_.-])(?!.*[_.-]$)(?!.*\s[_.-])(?!.*(?:[_.-]{2,}|([_.-])\1))[A-Za-z0-9_.-]+$/gi
export const ID_FORMAT = /[^A-Za-z0-9_.-]+/gi
export const NAME_CHECK =
  /^(?![.,\s-])(?!.*[.,\s-]$)(?!.*\s[.,-])(?!.*(?:[.,-]{2,}|([.,\s-])\1))(?!.*([A-Za-zÀ-ÖØ-öø-ÿ])\2\2)[A-Za-zÀ-ÖØ-öø-ÿ.,\s-]+$/gi
export const ONLY_NUMBERS_CHECK = /^[0-9\b]+$/
export const ONLY_NUMBERS_FORMAT = /[^0-9]/g
export const PASSWORD_CHECK = /^(?=.{8,}$)(?=.*?[a-z])(?=.*?[0-9]).*$/
export const NUMBER_FORMAT = /(\d)(?=(\d{3})+(?!\d))/g
export const NUMBER_LAST_POINT = /[^0-9.]|\.(?=.*\.)/g
export const NUMBER_LAST_COMMA = /[^0-9,]|,(?=,*,)/g
export const DNI_VALIDATION = /^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/
export const IS_NOT_ZERO = /^0+/
